var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.555 8.16782L12.555 2.16782C12.3908 2.05839 12.1978 2 12.0005 2C11.8032 2 11.6102 2.05839 11.446 2.16782L2.446 8.16782C2.3089 8.25905 2.19645 8.38273 2.11865 8.52788C2.04084 8.67302 2.00009 8.83513 2 8.99982V19.9998C2 21.1028 2.897 21.9998 4 21.9998H20C21.103 21.9998 22 21.1028 22 19.9998V8.99982C22 8.66582 21.833 8.35382 21.555 8.16782ZM12 4.20182L19.197 8.99982L12 13.7978L4.803 8.99982L12 4.20182ZM4 19.9998V10.8688L11.445 15.8318C11.6093 15.9415 11.8025 16 12 16C12.1975 16 12.3907 15.9415 12.555 15.8318L20 10.8688L19.997 19.9998H4Z",
    fill: "#20A8E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelop);
export default __webpack_public_path__ + "static/media/Envelop.96582bb2a047f12994b8e45ed0e8df8f.svg";
export { ForwardRef as ReactComponent };